<template>
  <svg viewBox="0 0 17 15" xmlns="http://www.w3.org/2000/svg">
    <g fill="#424256" stroke="#424256" stroke-width=".2" fill-rule="evenodd">
      <path d="M8.893 9.385c2.1 0 3.81-2.07 3.81-4.616S10.993.154 8.893.154c-2.099 0-3.81 2.07-3.81 4.615 0 2.546 1.715 4.616 3.81 4.616zm0-8.077c1.475 0 2.667 1.538 2.667 3.461 0 1.923-1.192 3.462-2.667 3.462-1.474 0-2.666-1.539-2.666-3.462 0-1.923 1.192-3.461 2.666-3.461z"/>
      <path d="M12.379 9a.576.576 0 0 0-.629.52.578.578 0 0 0 .515.634c1.772.21 3.145 1.664 3.268 3.461H2.253a3.761 3.761 0 0 1 3.269-3.461.578.578 0 0 0 .514-.635A.576.576 0 0 0 5.408 9c-.042 0-4.324.492-4.324 5.188 0 .32.256.577.571.577h14.476a.574.574 0 0 0 .572-.577C16.703 9.492 12.42 9 12.379 9z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ic-profile'
}
</script>
